<template>
  <div class="relative min-h-screen">
    <div class="fixed inset-0 z-0 vault-gradient pointer-events-none"></div>

    <!-- Navbar -->
    <nav class="relative z-10 w-full px-6 lg:px-12 py-8 flex justify-between items-center">
      <div class="flex items-center gap-3">
        <img src="/images/logo.png" style="height: 3.5rem;">
      </div>

      <a href="/login" class="text-sm font-semibold text-slate-600 hover:text-accent">
        Back to Login
      </a>
    </nav>

    <!-- Main -->
    <main class="relative z-10 flex items-center justify-center px-6 pb-20">
      <div class="login-gate w-full max-w-md rounded-xl p-8 md:p-10">

        <!-- Step Indicator -->
        <!-- <div class="text-center text-xs font-bold uppercase tracking-widest text-slate-400 mb-6">
          Step {{ step }} of 4
        </div> -->

        <!-- STEP CONTENT -->
        <div v-motion-fade-slide-bottom :key="step + '-' + otpSent+' '+isGoogleLogin" class="space-y-6">

          <!-- STEP 1: BASIC INFO -->
          <template v-if="step === 1">
            <h2 class="text-2xl font-extrabold">Basic information</h2>

            <input v-model="form.name" placeholder="Full name"
              class="input" />

            <input
              v-model="form.email"
              type="email"
              placeholder="Email address"
              class="input"
              @blur="validateEmail"
            />

            <div class="relative">
              <input
                v-model="form.password"
                :type="showPassword ? 'text' : 'password'"
                placeholder="Password"
                class="input pr-12"
                @blur="validatePassword"
              />

              <i
              class="bx absolute right-4 top-1/2 -translate-y-1/2 cursor-pointer text-slate-400"
              :class="showPassword ? 'bx-hide' : 'bx-show'"
              @click="showPassword = !showPassword"
            ></i>
            </div>
            <div class="flex gap-3">
              <select v-model="form.country" class="input w-1/3">
                <option
                  v-for="c in countryCodes"
                  :key="c.code"
                  :value="c.dial_code"
                >
                  {{ c.flag }} {{ c.dial_code }}
                </option>
              </select>

              <input
                  v-model="form.mobile"
                  type="tel"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  maxlength="12"
                  placeholder="Mobile number"
                  class="input w-2/3"
                  @input="form.mobile = form.mobile.replace(/\D/g, '')"
                />

               
            </div>
             <input
                  v-model="form.otp_code"
                  type="tel"
                  v-if="otpSent && !isGoogleLogin"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  maxlength="10"
                  placeholder="Otp Code Email"
                  class="input w-2/3"
                  @input="form.otp_code = form.otp_code.replace(/\D/g, '')"
                />

          </template>

          <!-- STEP 2: ACCOUNT TYPE -->
          <template v-if="step === 2">
            <h2 class="text-2xl font-extrabold text-center">
              Choose Account Type
            </h2>

            <div class="grid grid-cols-2 gap-4 pt-4">

              <div
                @click="form.utype = 'influencer'"
                :class="form.utype === 'influencer' ? 'type-card active' : 'type-card'"
              >
                <i class='bx bx-user'></i>
                <div>Influencer</div>
              </div>

              <div
                @click="form.utype = 'agancy'"
                :class="form.utype === 'agancy' ? 'type-card active' : 'type-card'"
              >
                <i class='bx bx-buildings'></i>
                <div>Brand</div>
              </div>

            </div>
          </template>


          <!-- STEP 2: BUSINESS INFO -->
          <template v-if="step === 3">
            <h2 class="text-2xl font-extrabold">
              {{ form.utype === 'influencer' ? 'Your creator profile' : 'Brand Profile' }}
            </h2>


            <!-- Influencer Fields -->
            <template v-if="form.utype === 'influencer'">

               <input v-model="form.username" placeholder="Username"
                class="input" />

              <select v-model="form.platform" class="input">
                <option disabled value="">Primary platform</option>
                <option>Instagram</option>
                <option>YouTube</option>
                <option>LinkedIn</option>
                <option>X (Twitter)</option>
              </select>

              <!-- <input v-model="form.niche" placeholder="Content niche" -->
                <!-- class="input" /> -->
              <select v-model="form.niche" class="input">
                <option disabled value="">Content niche</option>
                 <option value="fashion">Fashion</option>
                  <option value="beauty">Beauty</option>
                  <option value="fitness">Fitness</option>
                  <option value="tech">Tech</option>
                  <option value="gaming">Gaming</option>
                  <option value="food">Food</option>
                  <option value="travel">Travel</option>
                  <option value="finance">Finance</option>
                  <option value="education">Education</option>
                  <option value="lifestyle">Lifestyle</option>
                  <option value="parenting">Parenting</option>
                  <option value="luxury">Luxury</option>
                  <option value="other">Other</option>
              </select>

              <select v-model="form.followers" class="input">
                <option disabled value="">Follower range</option>
                <option>Under 10k</option>
                <option>10k – 50k</option>
                <option>50k – 250k</option>
                <option>250k+</option>
              </select>

            </template>

            <!-- Brand Fields -->
            <template v-else>

              <input v-model="form.agency_name" placeholder="Brand Name"
                class="input" />

              <input v-model="form.agency_company" placeholder="Company"
                class="input" />

              <input
                v-model="form.agency_website"
                type="text"
                placeholder="Website (example.com)"
                class="input"
                @blur="validateWebsite"
              />

            </template>

          </template>

          <!-- STEP 3: AUDIENCE LINK -->
          <template v-if="step === 4 && form.utype === 'influencer'">
            <h2 class="text-2xl font-extrabold">Grow your owned audience</h2>

            <p class="text-slate-500 text-sm">
              Share this link in your bio or post. Your audience joins you directly.
            </p>

            <div class="bg-slate-50 border rounded-lg p-4 font-mono text-sm break-all">
              {{ joinLink }}
            </div>

            <button @click="copyLink"
              class="w-full bg-slate-900 text-white font-bold py-3 rounded-lg">
              Copy link
            </button>
          </template>

          <!-- STEP 4: THANK YOU -->
          <!-- STEP 4: THANK YOU -->
        <template v-if="step === 5">
        <h2 class="text-2xl font-extrabold text-center">
            Thanks for joining
        </h2>

        <p class="text-center text-slate-500">
            Your creator profile has been submitted successfully.
        </p>

        <p class="text-center text-slate-500">
            Share your audience link to start building your owned community.
        </p>

        <button
            @click="continueNext"
            class="w-full mt-6 bg-primary text-white font-bold py-4 rounded-lg"
        >
            Continue
        </button>
        </template>


        </div>

             <div id="recaptcha" style="margin-top: 2rem;"></div>   
        <!-- ACTIONS -->
        <div class="flex justify-between pt-8">
          <button v-if="step > 1 && step < 4"
            @click="step--"
            class="text-sm font-bold text-slate-500">
            Back
          </button>

          <!-- <button
            v-if="step < 4"
            @click="next"
            class="ml-auto bg-primary text-white font-bold py-3 px-6 rounded-lg">
            {{ step === 3 ? 'Finish' : 'Continue' }}
          </button> -->
          <button
            v-if="step < 4"
            @click="next"
            :disabled="loading"
            class="ml-auto bg-primary text-white font-bold py-3 px-6 rounded-lg disabled:opacity-50"
          >
            <span v-if="loading">Please wait...</span>
            <span v-if="step === 1 && !otpSent && !isGoogleLogin">Send OTP</span>
            <span v-else-if="step === 1 && otpSent && !isGoogleLogin">Submit OTP</span>
            <span v-else-if="step === 3">Finish</span>
            <span v-else>Continue</span>
          </button>

        </div>

      </div>
    </main>
  </div>
</template>

<script>
import { signupApi,sendOtpNow } from "../apis/authapis";
import { useToast } from "vue-toastification";
import { nextTick } from "vue";
import { useRoute } from "vue-router";

export default {
  name: "SignupScreen",

  data() {
    return {
      mutype:"influencer",
      toast: useToast(),
      otp_txt:"",
      udata:null,
      otpSent:false,
      otpSent1:false,
      showPassword: false,
      step: 1,
      loading: false,
      countryCodes: [
        { name: "Afghanistan", dial_code: "+93", code: "AF", flag: "🇦🇫" },
        { name: "Albania", dial_code: "+355", code: "AL", flag: "🇦🇱" },
        { name: "Algeria", dial_code: "+213", code: "DZ", flag: "🇩🇿" },
        { name: "Andorra", dial_code: "+376", code: "AD", flag: "🇦🇩" },
        { name: "Angola", dial_code: "+244", code: "AO", flag: "🇦🇴" },
        { name: "Argentina", dial_code: "+54", code: "AR", flag: "🇦🇷" },
        { name: "Armenia", dial_code: "+374", code: "AM", flag: "🇦🇲" },
        { name: "Australia", dial_code: "+61", code: "AU", flag: "🇦🇺" },
        { name: "Austria", dial_code: "+43", code: "AT", flag: "🇦🇹" },
        { name: "Bangladesh", dial_code: "+880", code: "BD", flag: "🇧🇩" },
        { name: "Belgium", dial_code: "+32", code: "BE", flag: "🇧🇪" },
        { name: "Brazil", dial_code: "+55", code: "BR", flag: "🇧🇷" },
        { name: "Canada", dial_code: "+1", code: "CA", flag: "🇨🇦" },
        { name: "China", dial_code: "+86", code: "CN", flag: "🇨🇳" },
        { name: "Denmark", dial_code: "+45", code: "DK", flag: "🇩🇰" },
        { name: "Egypt", dial_code: "+20", code: "EG", flag: "🇪🇬" },
        { name: "France", dial_code: "+33", code: "FR", flag: "🇫🇷" },
        { name: "Germany", dial_code: "+49", code: "DE", flag: "🇩🇪" },
        { name: "Greece", dial_code: "+30", code: "GR", flag: "🇬🇷" },
        { name: "India", dial_code: "+91", code: "IN", flag: "🇮🇳" },
        { name: "Indonesia", dial_code: "+62", code: "ID", flag: "🇮🇩" },
        { name: "Ireland", dial_code: "+353", code: "IE", flag: "🇮🇪" },
        { name: "Israel", dial_code: "+972", code: "IL", flag: "🇮🇱" },
        { name: "Italy", dial_code: "+39", code: "IT", flag: "🇮🇹" },
        { name: "Japan", dial_code: "+81", code: "JP", flag: "🇯🇵" },
        { name: "Kenya", dial_code: "+254", code: "KE", flag: "🇰🇪" },
        { name: "Malaysia", dial_code: "+60", code: "MY", flag: "🇲🇾" },
        { name: "Mexico", dial_code: "+52", code: "MX", flag: "🇲🇽" },
        { name: "Netherlands", dial_code: "+31", code: "NL", flag: "🇳🇱" },
        { name: "New Zealand", dial_code: "+64", code: "NZ", flag: "🇳🇿" },
        { name: "Nigeria", dial_code: "+234", code: "NG", flag: "🇳🇬" },
        { name: "Norway", dial_code: "+47", code: "NO", flag: "🇳🇴" },
        { name: "Pakistan", dial_code: "+92", code: "PK", flag: "🇵🇰" },
        { name: "Philippines", dial_code: "+63", code: "PH", flag: "🇵🇭" },
        { name: "Poland", dial_code: "+48", code: "PL", flag: "🇵🇱" },
        { name: "Portugal", dial_code: "+351", code: "PT", flag: "🇵🇹" },
        { name: "Russia", dial_code: "+7", code: "RU", flag: "🇷🇺" },
        { name: "Saudi Arabia", dial_code: "+966", code: "SA", flag: "🇸🇦" },
        { name: "Singapore", dial_code: "+65", code: "SG", flag: "🇸🇬" },
        { name: "South Africa", dial_code: "+27", code: "ZA", flag: "🇿🇦" },
        { name: "South Korea", dial_code: "+82", code: "KR", flag: "🇰🇷" },
        { name: "Spain", dial_code: "+34", code: "ES", flag: "🇪🇸" },
        { name: "Sweden", dial_code: "+46", code: "SE", flag: "🇸🇪" },
        { name: "Switzerland", dial_code: "+41", code: "CH", flag: "🇨🇭" },
        { name: "Thailand", dial_code: "+66", code: "TH", flag: "🇹🇭" },
        { name: "Turkey", dial_code: "+90", code: "TR", flag: "🇹🇷" },
        { name: "UAE", dial_code: "+971", code: "AE", flag: "🇦🇪" },
        { name: "UK", dial_code: "+44", code: "GB", flag: "🇬🇧" },
        { name: "USA", dial_code: "+1", code: "US", flag: "🇺🇸" },
        { name: "Vietnam", dial_code: "+84", code: "VN", flag: "🇻🇳" }
      ],
      form: {
        name: "",
        email: "",
        otp_code:"",
        password: "",
        utype: "influencer",
        country: "+91",
        mobile: "",
        platform: "",
        niche: "",
        followers: "",
        username:""
      },
      otp: "",
      confirmationResult: null,
      joinLink: "",
      isGoogleLogin:false
    };
  },
  mounted(){
   
      var router = useRoute();
      const ldata = sessionStorage.getItem("udata");
      this.mutype = router.query.utype || "";
      if (ldata && ldata.length > 0) {
        this.udata = JSON.parse(ldata);
        this.step = 1;
        this.otp_txt = "123456";
        this.otpSent = true;
        this.form.name = this.udata.user_name;
        this.form.email = this.udata.user_email;
        this.isGoogleLogin = true;
      }
  },
  methods: {
   
   
    validateEmail() {
      const emailRegex =
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

      if (!this.form.email) {
        this.toast.error("Email required");
        return false;
      }

      if (!emailRegex.test(this.form.email)) {
        this.toast.error("Enter valid email address");
        return false;
      }

      return true;
    },

    validatePassword() {
      const passwordRegex = /^(?=.*[0-9]).{8,}$/;

      if (!this.form.password) {
        this.toast.error("Password required");
        return false;
      }

      if (!passwordRegex.test(this.form.password)) {
        this.toast.error(
          "Password must be 8+ characters and contain a number"
        );
        return false;
      }

      return true;
    },

    validateMobile() {
      const mobileRegex = /^[0-9]{7,15}$/;

      if (!this.form.mobile) {
        this.toast.error("Mobile required");
        return false;
      }

      if (!mobileRegex.test(this.form.mobile)) {
        this.toast.error("Enter valid mobile number");
        return false;
      }

      return true;
    },

    validateWebsite() {
  if (!this.form.agency_website) return true;

  try {
    let url = this.form.agency_website.trim();

    // Auto-add https if missing
    if (!/^https?:\/\//i.test(url)) {
      url = "https://" + url;
    }

    const parsed = new URL(url);

    // Must have valid hostname with dot
    if (!parsed.hostname.includes(".")) {
      throw new Error("Invalid domain");
    }

    // Save normalized URL back
    this.form.agency_website = parsed.href;

    return true;

  } catch (err) {
    this.toast.error("Enter a valid website link (example.com)");
    return false;
  }
},
    async next() {
      // ================= STEP 1 =================
      if (this.step === 1) {
        if (!this.form.name) {
          this.toast.error("Full name required");
          return;
        }
        

        if (!this.validateEmail()) return;
        if (!this.validateMobile()) return;
        if (!this.validatePassword()) return;

       


        if(this.otpSent==false){
          const res = await sendOtpNow(this.form.email,this.form.name);
          if (res.status) {
            this.otp_txt = res.otp_text+"";
            this.otpSent = true;

            await nextTick();
          }
          
        }
        else{
          if(this.otp_txt.toString().localeCompare(this.form.otp_code.toString())==0 || this.udata!=null){
            this.step = 3;
          }
          else{
            this.toast.error("Please Enter OTP");
          }
        }
        return;
      }

      // ================= STEP 2 =================
      if (this.step === 2) {

          if (!this.form.utype) {
            this.toast.error("Select account type");
            return;
          }

          this.step++;
          return;
        }


      // ================= STEP 3 =================
      if (this.step === 3) {

        if (this.form.utype === "influencer") {

          if (!this.form.username) {
            this.toast.error("Select username");
            return;
          }

          if (!this.form.platform) {
            this.toast.error("Select platform");
            return;
          }

          if (!this.form.niche) {
            this.toast.error("Content niche required");
            return;
          }

          if (!this.form.followers) {
            this.toast.error("Select follower range");
            return;
          }

        } else {
          if (!this.validateWebsite()) return;
          if (!this.form.agency_name) {
            this.toast.error("Brand name required");
            return;
          }

        }

        this.loading = true;
        
        const res = await signupApi({
          user_id: (this.udata!=null)? this.udata.user_id : "",
          user_name: this.form.name,
          user_email: this.form.email,
          user_mobile: this.form.country + this.form.mobile,
          user_password: this.form.password,
          user_type: this.form.utype,

          inf_platform: this.form.platform,
          inf_category: this.form.niche,
          inf_followers: this.form.followers,
          inf_username:this.form.username,

          agency_name: this.form.agency_name,
          agency_company: this.form.agency_company,
          agency_website: this.form.agency_website
        });

        this.loading = false;

        if (!res.status) {
          this.toast.error(res.success || "Signup failed");
          return;
        }
        sessionStorage.removeItem("udata");
        sessionStorage.setItem("ldata", JSON.stringify(res.user));

        // if (this.form.utype === "influencer") {
        //   this.joinLink = mainBaseUrl + "join/" + res.user.ven_dt.inf_username;
        //   this.step++;
        // } else {
        //   this.step = 5;
        //   setTimeout(() => {
        //     window.location.href = "/";
        //   }, 2000);
        // }

         window.location.href = "/";


        return;
      }

       if (this.step === 5) {
        setTimeout(() => {
          window.location.href = "/";
        }, 2000);

       }
    },

    copyLink() {
      navigator.clipboard.writeText(this.joinLink);

      this.toast.success("Invite link copied!", {
        timeout: 2000
      });
      window.location.href = "/";
    },

    continueNext() {
      window.location.href = "/";
    }
  }
};
</script>



<style scoped>
.input {
  width: 100%;
  background: rgba(248,250,252,0.6);
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  padding: 1rem;
  font-size: 1rem;
}

.type-card {
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 20px;
  text-align: center;
  font-weight: 700;
  cursor: pointer;
  background: #f8fafc;
  transition: 0.25s;
}

.type-card span {
  font-size: 28px;
  display: block;
  margin-bottom: 6px;
}

.type-card.active {
  background: black;
  color: white;
  border-color: black;
  transform: scale(1.03);
}

</style>
